import styled, { css } from 'styled-components'
import { DayCellWrapperProps } from './day-cell.component'

export const DayCellWrapper = styled.div<DayCellWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem; /* h-10 */
  width: 100%;
  transition:
    colors 0.15s,
    background-color 0.15s;
  cursor: pointer;

  ${(props) =>
    props.isSingleDayRange || props.isStart || props.isEnd || props.isPending
      ? css`
          background-color: #2563eb; /* bg-blue-600 */
          color: white;
          font-weight: 600; /* font-semibold */
        `
      : props.inRange
        ? css`
            background-color: #dbeafe; /* bg-blue-100 */
            color: #1d4ed8; /* text-blue-700 */
          `
        : css`
            color: #374151; /* text-gray-700 */
            &:hover {
              background-color: #f3f4f6; /* hover:bg-gray-100 */
            }
          `}
`
